// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3151I","footer":"Form_footer__lzpH6"};